export default {
  title: 'Insights Lab',
  search_placeholder: 'Search reports',
  see_all_reports: 'All reports',
  open_report: 'Open a report',
  open_report_named: 'Open %{title}',
  save_favorite: 'Save as favorite',
  add_favorite: 'Add %{title} to favorites',
  remove_favorite: 'Remove %{title} from favorites',
  load_error:
    'Something went wrong loading reports. Please refresh to try again.',
  report_error: 'This report could not be loaded. Please refresh to try again.',
  favorite_name: 'Name',
  favorite_description: 'Description',
  close_tab: 'Close %{title}',
  cancel: 'Cancel',
  save: 'Save',
  // Accessible name for the report iframe region (the visual title is set via
  // the iframe `title`; this names the embedded report for screen readers).
  report_region: '%{reportName} report',
  remove_favorite_modal: {
    title: 'Remove favorite?',
    description: 'Remove "%{name}" from your saved favorites?',
    cta: 'Remove',
  },
  picker: {
    title: 'All reports',
    favorites: 'Favorites',
    recommended: 'Recommended',
    search_placeholder: 'Search reports',
    no_reports: 'No reports match your search.',
    no_favorites: 'You have no saved favorites yet.',
    no_recommended: 'No recommended reports yet.',
    remove_favorite: 'Remove favorite %{name}',
    confirm_remove: 'Remove this favorite?',
    remove: 'Remove',
    cancel: 'Cancel',
    // Accessible name for a categorized report button — the category is only
    // visual otherwise, so fold it into the name screen readers announce.
    report_label: '%{title}, %{category}',
    // Visual affordance on each report row; purely decorative (the row's own
    // aria-label already names the button), so this text is not part of it.
    view_report: 'View Report',
    // Bridge banner pinned to the top of the Campaigns & rewards list,
    // pointing at the per-campaign reporting on the All campaigns page.
    campaign_bridge: {
      title: 'Looking for specific campaign reports?',
      description:
        'View reward redemption, purchase activity, and more for each campaign on the All campaigns page.',
      cta: 'Go to all campaigns',
    },
    // Visual affordance on the favorites row's remove-favorite control;
    // purely decorative (the button's own aria-label already names the
    // action), so this text is not part of its accessible name.
    favorited: 'Favorited',
  },
}
